export default "__VITE_ASSET__149aa126__"